import { SLIDING_RIGHT_PANEL_STATE } from './types';

export const slidingRightPanelRequestOpen = (payload: any) => ({
    type: SLIDING_RIGHT_PANEL_STATE,
    payload
});

export const toggleSlidingRightPanelStatus = (slidingState: boolean, currentComponent: string, componentData: any) => (
    dispatch: Function
) => {
    dispatch(slidingRightPanelRequestOpen({
        isOpen: slidingState,
        currentComponent,
        componentData
    }));
};

export type SlidingRightPanelActions = {
    type: string,
    payload?: any
};
